import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { CampaignsService } from 'src/app/services/campaigns.service';
import Swal from 'sweetalert2';
import { MainService } from 'src/app/services/main.service';

@Component({
  selector: 'app-distribution-art-preview',
  templateUrl: './distribution-art-preview.component.html',
  styleUrls: ['./distribution-art-preview.component.scss']
})
export class DistributionArtPreviewComponent implements OnInit {
  
  pdfUrl: SafeResourceUrl | null = null;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data : any,
    private campaignService : CampaignsService,
    private main : MainService,
    private sanitizer: DomSanitizer
  ) { }

  ngOnInit(): void {
    const pdfUrl = this.data?.artFiles?.[0]?.url_cli;

    if (this.isHttpUrl(pdfUrl)) {
      this.pdfUrl = this.sanitizer.bypassSecurityTrustResourceUrl(pdfUrl);
    }
  }

  private isHttpUrl(url?: string): boolean {
    if (!url) {
      return false;
    }

    try {
      const parsedUrl = new URL(url);
      return parsedUrl.protocol === 'https:' || parsedUrl.protocol === 'http:';
    } catch {
      return false;
    }
  }

}
